import React from "react"
import Button, { TButtonProps } from "../Button/Button"
import { useOverlay } from "../Overlay/OverlayProvider"

export type TConfirmProps = {
    msg:string
    className?:string
    buttonYes?:string
    buttonCancel?:string
    onYes:(dismiss:Function) => void
    onCancel?:Function,
    onDismissed?:Function,
    buttonYesProps?:TButtonProps
    buttonCancelProps?:TButtonProps
    content?:React.ReactNode
}
function Confirm(props:TConfirmProps&{id:string}) {
    const cancelProps = props.buttonCancelProps || {variant:"text"}
    const yesProps = props.buttonYesProps || {variant:"contained"}
    const {popOverlay} = useOverlay()

    const dismiss = () => popOverlay(props.id)
    const onCancel = () => {
        dismiss()
        props.onCancel?.()
    }
    const onYes = () => props.onYes(dismiss)
    return <>
        {props.msg ? <p>{props.msg}</p> : <></>}
        {props.content}
        <div className="actions">
            <Button {...cancelProps} onClick={onCancel}>{props.buttonCancel || "Cancel"}</Button>
            <Button {...yesProps} onClick={onYes}>{props.buttonYes || "Yes"}</Button>
        </div>
    </>
}

var g_id = 0
export default function useConfirm(){
    const {addOverlay} = useOverlay()

    const confirm = (props:TConfirmProps) =>{
        const id = `confirm_${g_id++}`
        const {onDismissed,...confirmProps} = props
        addOverlay(id, {children:<Confirm id={id} {...confirmProps}/>, className:"dialog confirm", onDismissed})
    }
    return {confirm}
}